<template>
	<div>
		<div class="header">
			<div class="back" @click="backClick"></div>
			<div class="title">{{ title }}</div>
			<div v-if="probability" class="probability" @click="probabilityClick"></div>
			<div v-else></div>
		</div>
		<div class="h124"></div>
	</div>
</template>
<script>
export default {
	data() {
		return {}
	},
	props: {
		title: {
			type: String,
			default: '',
		},
		probability: {
			type: Boolean,
			default: false,
		},
	},
	created() {
		console.log(this.$route.path)
	},
	methods: {
		backClick() {
            if(this.$route.path.includes('mybox')){
                this.$router.push({
                    path:'/blindBox',
                    replace:true
                })
                return;
            }
            history.go(-1)

			// if (this.backType === 'history') {
			//     history.go(-1)
			// } else {
			//     if (this.toFrom != '') {
			//         // this.$router.push({ path: '/welfare' })
			//         this.$emit('rolad')
			//         invokeNative({ 'methodName': 'dismissWebView' }, 'invokeMethod')
			//     } else {
			//         invokeNative({ 'methodName': 'dismissWebView' }, 'invokeMethod')
			//     }
			// }
		},
		probabilityClick() {
			this.$parent.fatherMethod()
		},
	},
}
</script>
<style lang="scss" scoped>
.header {
    width: 100%;
    height: 164px;
    line-height: 88px;
    padding: 60px 30px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: fixed;
    top: 0;
    z-index: 99;
    background:#1D0351;
    font-family: 'RobotoCondensed-Regular', 'Akrobat-ExtraBold', 'HelveticaNeue', 'Helvetica Neue', Helvetica, Arial, sans-serif;
    padding-top:constant(safe-area-inset-top);
    padding-top:env(safe-area-inset-top);
    .back {
        width: 48px;
        height: 48px;
        background: url('../../../assets/images/blindBox/icon_back.png') no-repeat;
        background-size: contain;
    }
    .title {
        font-size: 36px;
        font-weight: bold;
        position:relative;
        left:-24px;
        color: #fff;
    }
    .probability {
        width: 40px;
        height: 40px;
        background: url('../../../assets/images/blindBox/icon_57.png') no-repeat;
        background-size: contain;
    }
}
.h124 {
    height: 164px;
    width: 100%;
    // background: #17043D;
}
</style>
